import { reportService } from '../../helpers/services/report.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const REPORT_MODULE = 'report'; 

// define action 
export const GET_ALL_REPORTS = 'getAllReports';
export const GET_REPORT = 'getReport';
export const GET_REPORT_BY_REFERENCE_NUMBER = 'getReportByReferenceNumber';
export const UPDATE_REPORT = 'updateReport';
export const CREATE_REPORT = 'createReport';
export const UPDATE_REPORT_STATUS = 'updateReportStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_REPORT_REQUEST = "getAllReport";
const GET_REPORT_REQUEST = "getReport";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_REPORTS]({ commit }, { filter }) {
        reportService
            .getAllReports(filter)
            .then(
                (result) => {
                    commit(GET_ALL_REPORT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
   async [GET_REPORT]({ commit }, { id }) {
        await reportService
            .getReport(id)
            .then(
                (result) => {
                    commit(GET_REPORT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    async [GET_REPORT_BY_REFERENCE_NUMBER]({ commit }, { referenceNumber }) {
       await reportService
            .getReportByReferenceNumber(referenceNumber)
            .then(
                (result) => {
                    commit(GET_REPORT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_REPORT]({ commit }, { data }) {
        commit(REQUEST)
        reportService
            .updateReport(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.report')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_REPORT]({ commit }, { data }) {
        commit(REQUEST)
        reportService
            .createReport(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.report')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_REPORT_STATUS]({ dispatch }, { filter, data }) {
        reportService
            .updateReportStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_REPORTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )     
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Report-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = {processing: true};
    },
    [GET_ALL_REPORT_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                referenceNumber: o.reference_number,
                remark: o.remark,
                mileage: o.mileage,
                reportType: o.report_type,
                isComplete: o.is_complete,
                customerVehicle: o.customer_vehicle,
                companyLocation: o.company_location,
                parentReport: o.parent_report,
                subReport: o.sub_report,
                menuServices: o.menu_services,
                packages: o.packages,
                statusLog: o.status_logs,
                inspectionReport: o.inspection_report,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_REPORT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            referenceNumber: o.reference_number,
            remark: o.remark,
            mileage: o.mileage,
            reportType: o.report_type,
            isComplete: o.is_complete,
            customerVehicle: o.customer_vehicle,
            companyLocation: o.company_location,
            parentReport: o.parent_report,
            subReport: o.sub_report,
            menuServices: o.menu_services,
            packages: o.packages,
            statusLog: o.status_logs,
            inspectionReport: o.inspection_report,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }
    }
}


